import React from "react";
import LogoElement from "../../components/logo-element";
import Menu from "../../components/menu";
// import UserImage from "../../components/user-image";
// import UserMenu from "../../components/user-menu";
import UserName from "../../components/user-name";

const Aside = () => {
  return (
    <>
      <nav className="navbar-static-side" role="navigation">
        <div className="sidebar-collapse">
          <ul className="nav metismenu" id="side-menu">
            <li className="nav-header">
              <div className="dropdown profile-element">
                {/* <UserImage /> */}
                <UserName />
                {/* <UserMenu /> */}
              </div>
              <LogoElement />
            </li>
            <Menu />
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Aside;
